var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArgsExpGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_776_54923",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_776_54923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32512 13.2607C3.00429 13.3094 2.71505 13.234 2.45741 13.0347C2.19977 12.8354 2.05151 12.5753 2.01262 12.2545L1.2397 5.88158C1.20081 5.56074 1.27859 5.27394 1.47304 5.02116C1.66748 4.76838 1.92512 4.62255 2.24595 4.58366L2.91679 4.49616V9.25033C2.91679 9.89199 3.14526 10.4413 3.6022 10.8982C4.05915 11.3552 4.60845 11.5837 5.25012 11.5837H10.6751C10.6168 11.817 10.5001 12.0187 10.3251 12.1889C10.1501 12.359 9.93623 12.4587 9.68345 12.4878L3.32512 13.2607ZM5.25012 10.417C4.92929 10.417 4.65463 10.3028 4.42616 10.0743C4.19769 9.84581 4.08345 9.57116 4.08345 9.25033V2.83366C4.08345 2.51283 4.19769 2.23817 4.42616 2.0097C4.65463 1.78123 4.92929 1.66699 5.25012 1.66699H11.6668C11.9876 1.66699 12.2623 1.78123 12.4907 2.0097C12.7192 2.23817 12.8335 2.51283 12.8335 2.83366V9.25033C12.8335 9.57116 12.7192 9.84581 12.4907 10.0743C12.2623 10.3028 11.9876 10.417 11.6668 10.417H5.25012ZM8.45845 8.37533L10.5001 7.20866V4.87533L8.45845 3.70866L6.41679 4.87533V7.20866L8.45845 8.37533Z",
    fill: "rgba(24, 52, 98, 0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArgsExpGrey);
export default __webpack_public_path__ + "static/media/icon_args_exp_grey.d58bc671924d390ab69e51007eac4c23.svg";
export { ForwardRef as ReactComponent };